import styled from 'styled-components';

import {
  Input as SemanticInput,
} from 'semantic-ui-react';

import {
  Toggle as ToggleLayoutComponent,
} from '@playbookux/playbook-web-core';

const Toggle = styled(ToggleLayoutComponent)``;

const Text = styled.div`
  font-size: 14px;
  white-space: pre-wrap;
  user-select: text;
  color: ${({ theme }) => theme.color.text};

  ${({ rightMargin }) => rightMargin && 'margin-right: 5px'};
  ${({ leftMargin }) => leftMargin && 'margin-left: 5px'};
  ${({ bold }) => bold && 'font-weight: 500;'};
`;

const Input = styled(SemanticInput)`
  border-color: #CECECE;

  &&&.ui.input>input {
    border-radius: 8px;
    width: 300px;
  }
`;

const ContainerInput = styled.div`
  margin: 5px 0;
  padding: 0 14px;
`;

const ContainerSwitcher = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 16px 10px;
`;

const ContainerToggle = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const ContainerScroll = styled.div`
  max-height: 250px;
  overflow: auto;
`;

const Item = styled.div`
  width: 100%;
  padding: 11px 0px 11px 14px;
  color: ${({ theme }) => theme.color.text};


  ${({ itemSelected }) => itemSelected && `
    background: #F7F7F7;
    font-weight: 500;
  `};

  ${({ hover }) => hover && `
    &:hover {
      background: #F2F2F2;
      cursor: pointer;
  }
`};
  
`;

const ContainerToggleContent = styled.div`
  display: flex;
`;

const ContainerItem = styled.div`
  display: flex;
  justify-content: space-between;
  margin-right: 6px;
`;

const ListElementContainer = styled.div`
`;

export {
  Container,
  ContainerInput,
  Input,
  ContainerSwitcher,
  Toggle,
  ContainerToggle,
  Text,
  ContainerScroll,
  Item,
  ContainerToggleContent,
  ContainerItem,
  ListElementContainer,
};
